<!--
 * @Author: gzm
 * @Date: 2021-03-30 14:16:07
 * @Description:代码管理
-->
<!--
* www.cloudscope.cn
* Copyright (c) 2019. All Rights Reserved.
 -->
<template>
    <div class="warp-box data-list">
        <div class="header-box">
            <el-row>
                <el-col :span="18" class="searchInput">
                    <el-input
                        v-model="name"
                        placeholder="请输入关键词"
                        @keyup.enter.native="query"
                        class="idcard"
                    ></el-input>
                </el-col>
                <el-col :span="6" class="right-row">
                    <el-button
                        size="mini"
                        type="primary"
                        class="project-add"
                        @click="query"
                        style="margin-right: 10px"
                    >查询</el-button>
                    <el-button
                        size="mini"
                        type="primary"
                        class="project-add"
                        @click="addCode"
                        style="margin-right: 10px"
                    >新建</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="table-box">
            <el-table
                :data="tableData"
                style="width: 100%"
                height="400"
                v-loading="tableLoading"
                @selection-change="selectionChange"
            >
                <el-table-column type="selection" width="60" align="center"></el-table-column>
                <el-table-column type="index" width="80" label="序号" align="center"></el-table-column>
                <el-table-column prop="description" label="代码类型" align="center"></el-table-column>
                <el-table-column prop="codeType" label="代码前缀" align="center" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="createTime" label="创建日期" align="center"></el-table-column> -->
                <!-- <el-table-column prop="creater" label="创建人" align="center"></el-table-column> -->
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button @click="searchDetails(scope.row)">详情</el-button>
                        <el-button @click="exportCode(scope.row)">导出</el-button>
                        <el-button @click="createCode(scope.row)">生成代码</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <footer class="main-footer">
                <!-- 底部分页 -->
                <el-pagination
                    layout="total, sizes,  prev, pager, next, jumper"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="total"
                    @size-change="handleSizeChange"
                    @next-click="changePage"
                    @prev-click="changePage"
                    @current-change="changePage"
                ></el-pagination>
            </footer>
        </div>
        <el-dialog
            title="生成代码"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
        >
            <el-radio-group v-model="radio">
                <el-radio :label="'CLASS'">JAVA代码（constant风格）</el-radio>
                <el-radio :label="'ENUM'">JAVA代码（Enum风格）</el-radio>
                <el-radio :label="'JS'">Js代码</el-radio>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="BeMakeCode">确 定</el-button>
            </span>
        </el-dialog>
        <cs-code-management-dialog ref="CsCodeManagementDialog"></cs-code-management-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import CsCodeManagementDialog from './cs-codeManagementdialog.vue';
import { mapState } from 'vuex';
export default {
    data () {
        return {
            dialogVisible: false,
            name: '',
            tableLoading: false, // 表格loading
            currentPage: 1, // 当前页
            pageSize: 10, // 每页数量
            total: 0, // 总数
            tableData: [
                {
                    codeType: '典型设备',
                    codeEx: '1001',
                    createTime: '2021-06-17 11:00',
                    creater: '张三'
                }
            ],
            deleteIds: [],
            radio: '',
            codeTypeId: '',
            currentPageFlag: false
        };
    },

    components: {
        CsCodeManagementDialog
    },

    computed: {},

    watch: {},

    mounted () {
        this.query();
    },

    methods: {
        /**
         * @author: gzm
         * @description: 点击生成代码
         * @param {} {*}
         */
        async BeMakeCode () {
            axios({
                url: `/api/v1/auth/code/source/${this.radio}`,
                params: { codeTypeId: this.codeTypeId },
                method: 'get',
                headers: { 'Content-Type': 'application/json; application/octet-stream'},
                responseType: 'blob'
            }).then((res) => {
                // console.log(res);
            }).catch((error) => {
                console.log(error);
            });
        },
        /**
         * @author: gzm
         * @description: (导出)下载excel
         * @param {} {*}
         */
        exportCode (row) {
            axios({
                url: '/api/v1/auth/code/download/excel',
                params: { codeTypeId: row.id },
                method: 'get',
                headers: {'Content-Type': 'application/json; application/octet-stream'},
                responseType: 'blob'
            }).then((res) => {
                // console.log(res);
            }).catch((error) => {
                console.log(error);
            });
        },
        /**
         * @author: gzm
         * @description: 分页模糊查询
         * @param {} {*}
         */
        async query () {
            let filters = [];
            if (this.name) {
                let name = this.tableSearchNode(
                    'code_type',
                    'like',
                    [this.name],
                    'String'
                );
                let description = this.tableSearchNode(
                    'description',
                    'like',
                    [this.name],
                    'String'
                );
                filters.push([name, description]);
            }
            if (this.currentPageFlag) {
                this.currentPageFlag = false;
            } else {
                this.currentPage = 1;
            }
            let data = this.buildQueryBean(this.currentPage, this.pageSize, filters);
            this.tableLoading = true;
            let res = await this.$api.CodeManagement.limits(data);
            this.total = parseInt(res.data.total);
            this.tableData = res.data.list;
            this.tableLoading = false;
        },
        // 改变当前页
        changePage (val) {
            this.currentPage = val;
            this.currentPageFlag = true;
            this.query();
        },
        // 改变每页展示个数
        handleSizeChange (val) {
            this.pageSize = val;
            this.query();
        },
        // 多选
        selectionChange (row) {
            let arr = [];
            for (let i = 0; i < row.length; i++) {
                arr[i] = row[i].id;
            }
            this.deleteIds = arr;
        },
        /**
         * @author: gzm
         * @description: 点击生成代码按钮后触发对话框
         * @param {} {*}
         */
        createCode (row) {
            this.codeTypeId = row.id;
            this.dialogVisible = true;
        },
        /**
         * @author: gzm
         * @description: 点击新建和详情按钮打开代码值的对话框
         * @param {} {*}
         */
        addCode () {
            this.$refs.CsCodeManagementDialog.dialogVisible = true;
            this.$refs.CsCodeManagementDialog.inputMultValue = '';
            this.$refs.CsCodeManagementDialog.inputDesValue = '';
            this.$refs.CsCodeManagementDialog.codeExdisabled = false;
        },
        async searchDetails (row) {
            this.$refs.CsCodeManagementDialog.dialogVisible = true;
            this.$refs.CsCodeManagementDialog.inputMultValue = row.codeType;
            this.$refs.CsCodeManagementDialog.inputDesValue = row.description;
            this.$refs.CsCodeManagementDialog.codeExdisabled = true;
            this.$refs.CsCodeManagementDialog.codeTypeIdNew = row.id;
            this.$refs.CsCodeManagementDialog.show(row);
        },
        handleClose () {
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang='scss' scoped>
/deep/.warp-box {
    .header-box {
        margin-bottom: 10px;
        .el-input {
            // width: 230px !important;
            height: 40px;
            line-height: 40px;
            background: #ffffff;
            border: none;
            border-radius: 20px;
            .el-input__inner {
                height: 40px !important;
                line-height: 40px;
                border-radius: 20px !important;
                border: none;
                background: #ffffff;
                color: #333333;
            }
            .el-input__suffix {
                right: 10px;
            }
            .el-input__icon {
                font-size: 18px;
            }
        }
        .right-row {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            .project-add {
                width: 100px;
                height: 40px;
                color: #fff;
                font-size: 14px;
                border-radius: 20px;
                // background: #fea103;
            }
            span {
                // display: inline-block;
                margin-top: 8px;
                margin-right: 0px;
                cursor: pointer;
                svg {
                    width: 16px;
                    height: 16px;
                    color: #a0a4b8;
                }
            }
        }
    }
    .el-table {
        height: calc(100vh - 210px) !important;
        .el-button {
            padding: 8px 20px;
            border-radius: 20px;
        }
    }
}
.searchInput {
    .title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        padding-left: 6px;
        border-left: 4px solid #fea103;
        display: inline-block;
        margin-right: 13px;
    }
}

.activeBut {
    // background: #fea103;
    color: #fff !important;
}
.typeBut {
    color: #31364e !important;
}
.el-button--mini {
    padding: 0;
    font-size: 14px;
    border-radius: 20px;
    width: 70px;
    height: 40px;
    // background: #FEA103;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
}
.idcard {
    width: 120px;
    margin-right: 10px;
    .el-input__inner {
        width: 110px;
    }
}
.el-radio {
    display: block;
    height: 32px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// ./src/components/Comencapsulation/cs-codemanagement.vue